
import arMessages from '../locales/ar_AR';

const ArLang = {
    messages: {
        ...arMessages
    },
    locale: 'ar-AR',
   
};
export default ArLang;